var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2338 45.2294C48.9342 41.529 44.0255 30.6206 34.2697 20.8649C24.514 11.1092 13.6056 6.20038 9.9052 9.90083C6.20476 13.6013 11.1135 24.5096 20.8692 34.2654C30.625 44.0211 41.5333 48.9298 45.2338 45.2294Z",
    stroke: "#3877F7",
    strokeWidth: 3.44567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2697 34.2657C44.0255 24.51 48.9342 13.6017 45.2338 9.90122C41.5333 6.20077 30.625 11.1095 20.8692 20.8653C11.1135 30.621 6.20476 41.5293 9.9052 45.2298C13.6056 48.9302 24.514 44.0215 34.2697 34.2657Z",
    stroke: "#3877F7",
    strokeWidth: 3.44567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5653 30.1495C28.9926 30.1495 30.1496 28.9924 30.1496 27.5652C30.1496 26.138 28.9926 24.981 27.5653 24.981C26.1381 24.981 24.9811 26.138 24.9811 27.5652C24.9811 28.9924 26.1381 30.1495 27.5653 30.1495Z",
    fill: "#437EF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bca800cb09ce728d01b330860338f808.svg";
export { ForwardRef as ReactComponent };